"use client"
import { FaPlus, FaArrowRight } from "react-icons/fa"

const OrderFormStep1 = ({
  handleStep1Submit,
  address,
  handleAddressChange,
  storedAddresses,
  product,
  normalizeString,
  state,
  pincode,
  setAddress,
  setState,
  setPincode,
  setSelectedCode,
  setSelectedSiteBalance,
  setAccountDetails,
  showNewSiteForm,
  setShowNewSiteForm,
  handleSiteSelection,
  filteredAddresses,
  statesList,
  handleStateChange,
  handlePincodeChange,
  selectedGrade,
  handleGradeSelection,
  selectedMt,
  handleMtChange,
  mt,
  selectedQuantity,
  handleQuantityChange,
  quantities,
  customQuantity,
  setCustomQuantity,
  isStep1Complete,
}) => {
  return (
    <form onSubmit={handleStep1Submit}>
      <div className="site-address-field">
        <div className="orderForm-group full-width">
          <label htmlFor="address" className="form-label-static">
            Site Address:
          </label>

          {/* Show existing sites with checkboxes if available */}
          {storedAddresses.filter((addr) => addr.brand === product.name).length > 0 ? (
            <>
              <div className="existing-sites-container">
                {storedAddresses
                  .filter((addr) => addr.brand === product.name)
                  .map((addr, index) => (
                    <div key={index} className="site-option">
                      <input
                        type="checkbox"
                        id={`site-${index}`}
                        checked={
                          normalizeString(address) === normalizeString(addr.address) &&
                          normalizeString(state) === normalizeString(addr.state) &&
                          normalizeString(pincode) === normalizeString(addr.pincode)
                        }
                        onChange={() => {
                          if (address === addr.address && state === addr.state && pincode === addr.pincode) {
                            setAddress("")
                            setState("")
                            setPincode("")
                            setSelectedCode(null)
                            setSelectedSiteBalance(0)
                            setAccountDetails(null)
                          } else {
                            if (showNewSiteForm) {
                              setShowNewSiteForm(false)
                            }
                            handleSiteSelection(addr)
                          }
                        }}
                        className="site-checkbox"
                      />
                      <label htmlFor={`site-${index}`} className="site-label">
                        {addr.address}, {addr.state}, {addr.pincode}
                      </label>
                    </div>
                  ))}
              </div>

              <button
                type="button"
                className="add-new-site-btn"
                onClick={() => {
                  setAddress("")
                  setState("")
                  setPincode("")
                  setSelectedCode(null)
                  setSelectedSiteBalance(0)
                  setAccountDetails(null)
                  setShowNewSiteForm(true)
                }}
              >
                <FaPlus className="add-icon" /> Add New Site
              </button>
            </>
          ) : (
            <>
              <input
                type="text"
                id="address"
                value={address}
                onChange={handleAddressChange}
                required
                maxLength={100}
                placeholder="Enter your Site Address"
                className="product-form-input"
              />
              {filteredAddresses.length > 0 && (
                <ul className="address-dropdown">
                  {filteredAddresses.map((addr, index) => (
                    <li
                      key={index}
                      onClick={() => handleSiteSelection(addr)}
                      className={addr.brand === product.name ? "address-with-balance" : ""}
                    >
                      {addr.address}, {addr.state}, {addr.pincode}
                      {addr.brand === product.name && addr.balance > 0 && (
                        <span className="address-balance">Balance: ₹{addr.balance.toLocaleString("en-IN")}</span>
                      )}
                    </li>
                  ))}
                </ul>
              )}
            </>
          )}
        </div>
      </div>

      {/* New site form that appears when "Add New Site" is clicked */}
      {showNewSiteForm && (
        <div className="new-site-form">
          <div className="orderForm-group full-width">
            <label htmlFor="newAddress" className="form-label-static">
              New Site Address:
            </label>
            <input
              type="text"
              id="newAddress"
              value={address}
              onChange={handleAddressChange}
              required
              maxLength={100}
              placeholder="Enter your Site Address"
              className="product-form-input"
            />
          </div>

          <div className="orderForm-row">
            <div className="orderForm-group">
              <label htmlFor="state" className="form-label-static">
                State:
              </label>
              <select id="state" value={state} onChange={handleStateChange} required className="product-form-select">
                <option value="">Select State</option>
                {statesList.map((stateName, index) => (
                  <option key={index} value={stateName}>
                    {stateName}
                  </option>
                ))}
              </select>
            </div>

            <div className="orderForm-group">
              <label htmlFor="pincode" className="form-label-static pincode-label">
                Pincode (Optional):
              </label>
              <input
                type="text"
                id="pincode"
                value={pincode}
                onChange={handlePincodeChange}
                placeholder="Enter your pincode"
                className="product-form-input"
                maxLength={6}
              />
              {pincode.length > 6 && <span className="error-text">Pincode must be 6 digits</span>}
            </div>
          </div>

          <div className="new-site-actions">
            <button type="button" className="cancel-new-site" onClick={() => setShowNewSiteForm(false)}>
              Cancel
            </button>
          </div>
        </div>
      )}

      {/* Default state and pincode shown only when new form is not visible */}
      {!showNewSiteForm && storedAddresses.filter((addr) => addr.brand === product.name).length === 0 && (
        <div className="orderForm-row">
          <div className="orderForm-group">
            <label htmlFor="state" className="form-label-static">
              State:
            </label>
            <select id="state" value={state} onChange={handleStateChange} required className="product-form-select">
              <option value="">Select State</option>
              {statesList.map((stateName, index) => (
                <option key={index} value={stateName}>
                  {stateName}
                </option>
              ))}
            </select>
          </div>

          <div className="orderForm-group">
            <label htmlFor="pincode" className="form-label-static pincode-label">
              Pincode (Optional):
            </label>
            <input
              type="text"
              id="pincode"
              value={pincode}
              onChange={handlePincodeChange}
              placeholder="Enter your pincode"
              className="product-form-input"
              maxLength={6}
            />
            {pincode.length > 6 && <span className="error-text">Pincode must be 6 digits</span>}
          </div>
        </div>
      )}

      <div className="orderForm-group full-width">
        <label className="form-label-static">Grade Selection:</label>
        <div className="product-button-group">
          {["OPC43", "OPC53", "PPC", "PSC"].map((grade) => (
            <button
              type="button"
              key={grade}
              className={`option-btn ${selectedGrade === grade ? "selected" : ""}`}
              onClick={() => handleGradeSelection(grade)}
            >
              {grade}
            </button>
          ))}
        </div>

        <div className="orderForm-row">
          {product.category?.toLowerCase() !== "cement" && (
            <div className="orderForm-group">
              <label className="form-label-static mt-3">MT Selection:</label>
              <select id="mt" value={selectedMt} onChange={handleMtChange} required className="product-form-select">
                <option value="">Select MT</option>
                {mt.map((mtValue, index) => (
                  <option key={index} value={mtValue}>
                    {mtValue}
                  </option>
                ))}
              </select>
            </div>
          )}

          {/* Quantity Selection - Hidden for Bulker Cement */}
          {product.category?.toLowerCase() !== "bulker cement" && (
            <div className="orderForm-group">
              <label className="form-label-static mt-3">Quantity (bags):</label>

              <div className="quantity-row">
                <select
                  id="quantity"
                  value={selectedQuantity}
                  onChange={handleQuantityChange}
                  required
                  className="product-form-select full-width"
                >
                  <option value="">Select Quantity</option>
                  {quantities.map((qty, index) => (
                    <option key={index} value={qty}>
                      {qty}
                    </option>
                  ))}
                </select>

                {selectedQuantity === "Other" && (
                  <input
                    type="number"
                    id="customQuantity"
                    value={customQuantity}
                    onChange={(e) => {
                      const value = Number(e.target.value)
                      setCustomQuantity(value)
                    }}
                    required
                    placeholder="Custom quantity"
                    className="product-form-input full-width"
                    onWheel={(e) => e.target.blur()}
                  />
                )}
              </div>

              {(customQuantity < 240 || customQuantity > 100000) && customQuantity !== "" && (
                <p className="error-message">Quantity must be between 240 and 100000</p>
              )}
            </div>
          )}
        </div>
      </div>

      <div className="action-buttons">
        <button
          type="submit"
          className={`action-btn next-step ${isStep1Complete ? "active" : ""}`}
          disabled={!isStep1Complete}
        >
          Confirm and Proceed <FaArrowRight className="ml-2" />
        </button>
      </div>
    </form>
  )
}

export default OrderFormStep1
